import { addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { TagToCreate, Tag } from "../types";
import { TagDB } from "./Tags";

export const createTag = async (tag: TagToCreate): Promise<Tag> => {
  const collectionRef = collection(db, "tags");

  const tagRef = await addDoc(collectionRef, {
    ...tag,
    createdAt: new Date(),
  });

  const newTagSnapshot = await getDoc(tagRef);

  const newTag = new TagDB(newTagSnapshot);

  return newTag.toTag();
};
